import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useFirebaseApp } from "reactfire";
import Logo from "../../Assets/img/logo.png";

const useStyles = makeStyles((theme) => ({
  root: { height: "100vh" },
  paper: { margin: theme.spacing(8, 4), display: "flex", flexDirection: "column", alignItems: "center" },
  form: { width: "60%", marginTop: theme.spacing(1) },
  submit: { margin: theme.spacing(3, 0, 2), backgroundColor: "#176AA7" },
}));

export default function Login() {
  const [emailstate, setEmail] = useState("");
  const [passwordstate, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // Estado para el error
  const [showPassword, setShowPassword] = useState(false);

  let fb = useFirebaseApp();
  let History = useHistory();
  const classes = useStyles();

  const SignIn = () => {
    setErrorMessage(""); // Limpia el error previo
  
    fb.auth()
      .signInWithEmailAndPassword(emailstate, passwordstate)
      .then(() => History.push("/"))
      .catch(() => setErrorMessage("⚠️ Correo o contraseña incorrectos. Verifica tus datos."));
  };
  

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} sm={12} md={12} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <img style={{ width: '350px', height: 'auto' }} src={Logo} alt="logo" />
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Correo electrónico"
              autoComplete="email"
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                      onClick={() => setShowPassword((v) => !v)}
                      onMouseDown={(e) => e.preventDefault()}
                      edge="end"
                    >
                      {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {errorMessage && ( // Muestra el mensaje de error si existe
              <Typography color="error" variant="body2" align="center">
                {errorMessage}
              </Typography>
            )}

            <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={SignIn}>
              Entrar
            </Button>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}
